import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";

const ShopifyDirectInstall = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const temp_id = searchParams.get("temp_id");

  useEffect(() => {
    const userData = localStorage.getItem("ship_rocket_user");
    if (!userData) {
      // Not logged in, save temp_id so we can link after login
      navigate(`/login?pendingShopifyInstall=${temp_id}`);
      return;
    }

    const { customer_id } = JSON.parse(userData);

    // Link the Shopify store to this customer
    axios.post(`https://skyshipbackend.fniix.com/auth/link_shopify_store`, {
      temp_id,
      customer_id,
    })
      .then((res) => {
        const { success, message } = res.data;
        if (message === "already_connected") {
          Swal.fire({
            icon: "success",
            title: "Store already connected ,This Shopify store is already linked to any other account.",
            timer: 2000,
            showConfirmButton: false,
          });
          navigate("/channel_list?status=already_connected");
          // window.location.replace("/channel_list?status=already_connected");
          return;
        }

        if (success) {

        Swal.fire({
          icon: "success",
          title: "Shopify store connected successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
        navigate("/channel_list?status=success");
      }
      else{
        Swal.fire({
          icon: "error",
          title: "Failed to link Shopify store",
        });
        navigate("/channel_list?status=failed");
      }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Failed to link Shopify store",
        });
        navigate("/channel_list?status=failed");
      });
  }, [navigate, temp_id]);

  return null;
};

export default ShopifyDirectInstall;